const newFonts = [
  {
    url: "https://fonts.googleapis.com/css2?family=Abril+Fatface",
    name: "Abril Fatface",
    cssName: "'Abril Fatface', cursive",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Architects+Daughter",
    name: "Architects Daughter",
    cssName: "'Architects Daughter', cursive",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Asap",
    name: "Asap",
    cssName: "'Asap', sans-serif",
    weight: [400, 500, 600, 700],
    italic: true,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Balsamiq+Sans",
    name: "Balsamiq+Sans",
    cssName: "'Balsamiq Sans', cursive",
    weight: [400, 700],
    italic: true,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Barlow:wght",
    name: "Barlow",
    cssName: "'Barlow', sans-serif",
    weight: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    italic: true,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Bebas+Neue",
    name: "Bebas+Neue",
    cssName: "'Bebas Neue', cursive",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Bitter",
    name: "Bitter",
    cssName: "'Bitter', serif",
    weight: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    italic: true,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Cabin",
    name: "Cabin",
    cssName: "'Cabin', sans-serif",
    weight: [400, 500, 600, 700],
    italic: true,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Cairo",
    name: "Cairo",
    cssName: "'Cairo', sans-serif",
    weight: [200, 300, 400, 500, 600, 700, 900],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Cormorant+Garamond",
    name: "Cormorant+Garamond",
    cssName: "'Cormorant Garamond', serif",
    weight: [300, 400, 500, 600, 700],
    italic: true,
  },
  // {
  //     url: "",
  //     name: "Crimson Text",
  //     cssName: '',
  //     weight: [],
  //     italic: false,
  // },
  {
    url: "https://fonts.googleapis.com/css2?family=Crimson+Pro",
    name: "Crimson+Pro",
    cssName: "'Crimson Pro', serif",
    weight: [200, 300, 400, 500, 600, 700, 800, 900],
    italic: true,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Fira+Sans",
    name: "Fira+Sans",
    cssName: "'Fira Sans', sans-serif",
    weight: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Fjalla+One",
    name: "Fjalla+One",
    cssName: "'Fjalla One', sans-serif",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Indie+Flower",
    name: "Indie+Flower",
    cssName: "'Indie Flower', cursive",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Josefin+Sans",
    name: "Josefin+Sans",
    cssName: "'Josefin Sans', sans-serif",
    weight: [100, 200, 300, 400, 500, 600, 800, 700, 900],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Lato",
    name: "Lato",
    cssName: "'Lato'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Libre+Baskerville",
    name: "Libre+Baskerville",
    cssName: "'Libre Baskerville'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Libre+Franklin",
    name: "Libre+Franklin",
    cssName: "'Libre Franklin'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Lobster",
    name: "Lobster",
    cssName: "'Lobster'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Lora",
    name: "Lora",
    cssName: "'Lora'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Martel",
    name: "Martel",
    cssName: "'Martel'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Merriweather",
    name: "Merriweather",
    cssName: "'Merriweather'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Mukta",
    name: "Mukta",
    cssName: "'Mukta'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Noto+Sans",
    name: "Noto+Sans",
    cssName: "'Noto Sans'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Nunito",
    name: "Nunito",
    cssName: "'Nunito'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Nunito+Sans",
    name: "Nunito+Sans",
    cssName: "'Nunito Sans'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Old+Standard+TT",
    name: "Old+Standard+TT",
    cssName: "'Old Standard TT'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Open+Sans",
    name: "Open+Sans",
    cssName: "'Open Sans'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Oswald",
    name: "Oswald",
    cssName: "'Oswald'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Overpass",
    name: "Overpass",
    cssName: "'Overpass'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Oxygen",
    name: "Oxygen",
    cssName: "'Oxygen'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Pacifico",
    name: "Pacifico",
    cssName: "'Pacifico'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Playfair+Display",
    name: "Playfair+Display",
    cssName: "'Playfair Display'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Poppins",
    name: "Poppins",
    cssName: "'Poppins'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=PT+Sans",
    name: "PT+Sans",
    cssName: "'PT Sans'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Raleway",
    name: "Raleway",
    cssName: "'Raleway'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Roboto+Condensed",
    name: "Roboto+Condensed",
    cssName: "'Roboto Condensed'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Roboto+Slab",
    name: "Roboto+Slab",
    cssName: "'Roboto Slab'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Rubik",
    name: "Rubik",
    cssName: "'Rubik'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Source+Code+Pro",
    name: "Source+Code+Pro",
    cssName: "'Source Code Pro'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Source+Sans+Pro",
    name: "Source+Sans+Pro",
    cssName: "'Source Sans Pro'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Tajawal",
    name: "Tajawal",
    cssName: "'Tajawal'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Titillium+Web",
    name: "Titillium+Web",
    cssName: "'Titillium Web'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Ubuntu",
    name: "Ubuntu",
    cssName: "'Ubuntu'",
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css2?family=Work+Sans",
    name: "Work+Sans",
    cssName: "'Work Sans'",
    weight: [400],
    italic: false,
  },
];

export const fontList = [

  {
    url: "https://fonts.cdnfonts.com/css/helvetica-neue-9",
    name: "Helvetica",
    cssName: '"Helvetica Neue", sans-serif',
    weight: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css?family=Calistoga",
    name: "Calistoga",
    cssName: '"Calistoga", cursive',
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css?family=Dancing+Script:400,500,600,700",
    name: "Dancing+Script",
    cssName: '"Dancing Script", cursive',
    weight: [400, 500, 600, 700],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css?family=Great+Vibes",
    name: "Great+Vibes",
    cssName: '"Great Vibes", sans-serif',
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css?family=Gupter:400,500,700",
    name: "Gupter",
    cssName: '"Gupter", serif',
    weight: [400, 500, 700],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css?family=Montserrat:300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i",
    name: "Montserrat",
    cssName: '"Montserrat", sans-serif',
    weight: [300, 400, 500, 600, 700, 800, 900],
    italic: true,
  },
  {
    url: "https://fonts.googleapis.com/css?family=Noto+Serif:400,400i,700,700i",
    name: "Noto+Serif",
    cssName: '"Noto Serif", serif',
    weight: [400, 700],
    italic: true,
  },
  {
    url: "https://fonts.googleapis.com/css?family=Odibee+Sans",
    name: "Odibee+Sans",
    cssName: '"Odibee Sans", cursive',
    weight: [400],
    italic: true,
  },
  {
    url: "https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i,800,800i",
    name: "Open+Sans",
    cssName: '"Open Sans", sans-serif',
    weight: [300, 400, 600, 700, 800],
    italic: true,
  },
  {
    url: "https://fonts.googleapis.com/css?family=Oswald:200,300,400,500,600,700",
    name: "Oswald",
    cssName: '"Oswald", sans-serif',
    weight: [200, 300, 400, 500, 600, 700],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css?family=Roboto+Condensed:300,300i,400,400i,700,700i",
    name: "Roboto+Condensed",
    cssName: '"Roboto Condensed", sans-serif',
    weight: [300, 400, 700],
    italic: true,
  },
  {
    url: "https://fonts.googleapis.com/css?family=Roboto:300,300i,400,400i,500,500i,700,700i,900,900i",
    name: "Roboto",
    cssName: '"Roboto", sans-serif',
    weight: [300, 400, 500, 700, 900],
    italic: true,
  },
  {
    url: "https://fonts.googleapis.com/css?family=Shadows+Into+Light",
    name: "Shadows+Into+Light",
    cssName: '"Shadows Into Light", cursive',
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css?family=Slabo+27px",
    name: "Slabo+27px",
    cssName: '"Slabo 27px", serif',
    weight: [400],
    italic: false,
  },
  {
    url: "https://fonts.googleapis.com/css?family=Vidaloka&display=swap",
    name: "Vidaloka",
    cssName: '"Vidaloka", serif',
    weight: [400],
    italic: false,
  },
  ...newFonts,
];
